import { FC } from 'react';
import { Button } from 'learning-panel-components';
import { useNavigate } from 'react-router-dom';
import { translate } from 'translations';
import styles from './quizExitPopup.module.scss';

const QuizExitPopup: FC<QuizExitPopupProps> = (props: QuizExitPopupProps) => {
    const { setIsPopupOpen } = props;
    const navigate = useNavigate();

    const onStay = () => {
        setIsPopupOpen(false);
    };

    const OnQuitTest = () => {
        navigate('/app/home');
    };

    return (
        <div className={styles['background-wrapper']}>
            <div
                className={styles['pop-up-wrapper']}
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/accountSettings.svg)` }}
            >
                <div className={styles['text-wrapper']}>
                    <div className={styles['main-text']}>
                        {translate('AreYouSureYouWantTo')}
                        <span className={styles['bold-text']}>{translate('QuitTheTest')}</span>?
                    </div>
                    <div className={styles['sub-text']}>{translate('ExitingNowCountsAsTestAttempt')}</div>
                    <div className={styles['sub-text']}>
                        {translate('AnyProgressAndAchievements')}
                        <span className={styles['bold-text']}>{translate('WillNotBeSaved')}</span>.
                    </div>
                </div>
                <div className={styles['bottom-wrapper']}>
                    <div className={styles.home} onClick={OnQuitTest}>
                        {translate('QuitTest')}
                    </div>
                    <div>
                        <Button
                            id="stay-button"
                            type={'bigGradient'}
                            onClick={onStay}
                            text={translate('Stay')}
                            lowerCase
                            className={styles.button}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

interface QuizExitPopupProps {
    setIsPopupOpen: Function;
}

export default QuizExitPopup;
